import styled from 'styled-components';

const StyledArrowIcon = styled.div`
  color: inherit;
  stroke: inherit;
  transform: translateY(1px);

  svg {
    margin-left: 12px;
    color: inherit;
    font-size: 10px;
    stroke: currentColor;
    stroke-width: 2px;
  }
`;

export { StyledArrowIcon };
